import { assessmentQuestionsEn } from "./data/assessmentData.en";
import {
  CROSS_P2_EN,
  CROSS_P3_EN_AVANCE_EN,
  CROSS_P3_EN_RETRAIT_EN,
  CROSS_P3_UNIFORME_EN,
  PILLAR_FEEDBACKS_EN,
} from "./data/feedbackData.en";
import type { LocaleStrings } from "./utils";

const en: LocaleStrings = {
  ui: {
    "nav.previous": "Previous",
    "nav.next": "Next",
    "nav.results": "Results",
    "groups.1": "Strategy & Steering",
    "groups.2": "Brand & Experience",
    "groups.3": "Content & Visibility",
    "groups.4": "AI & Tools",
    "welcome.title": "What is your organisation's marketing maturity level?",
    "welcome.cta": "Get started",
    "welcome.tagline": "Immediate results · No commitment",
    "welcome.intro.bold": `${assessmentQuestionsEn.length} questions. A tailored assessment.`,
    "welcome.intro.p1":
      "B2B marketing is at a tipping point. AI is redefining the expertise of marketing teams — amplifying strengths and weaknesses alike.",
    "welcome.intro.p2":
      "What worked two years ago is no longer enough. What will work tomorrow is not yet clear to everyone.",
    "welcome.intro.p3":
      "This assessment evaluates your marketing across four dimensions: strategy, brand, content and AI. Its goal is to bring you clarity by identifying THE priority for moving forward.",
    "welcome.summary.title": "In summary",
    "welcome.summary.li1": "{n} questions",
    "welcome.summary.li2": "4 dimensions: strategy, brand, content and AI",
    "welcome.summary.li3": "Immediate results · No commitment",
    "emailCapture.emailLabel":
      "Leave your email to save your progress and receive your results at the end.",
    "emailCapture.emailPlaceholder": "Your professional email",
    "emailCapture.emailPrivacy":
      "Your email stays with us. We won't share it with anyone. Promise.",
    "emailCapture.errorEmpty": "Please enter your email",
    "emailCapture.errorInvalid": "Please enter a valid email",
    "emailCapture.errorEmailForLink":
      "Please enter your email to receive the resume link",
    "emailCapture.errorCompany": "Please enter your company name",
    "emailCapture.company.title": "Let's verify your company",
    "emailCapture.company.withSuggestion":
      "We identified this company from your email. Can you confirm or correct it?",
    "emailCapture.company.noSuggestion":
      "We couldn't automatically find your company. Could you tell us?",
    "emailCapture.company.placeholder": "Your company name",
    "emailCapture.continue": "Continue",
    "emailCapture.pauseLater.hint":
      "No time right now? Enter your email above and you'll receive a link to resume exactly where you left off.",
    "emailCapture.pauseLater.button": "Resume later",
    "emailCapture.previous": "Previous",
    "emailCapture.themeTitle": "Theme 1:",
    "companyCapture.title": "Before your results",
    "companyCapture.subtitle":
      "We're preparing your summary. Can you confirm your company to personalise the results correctly?",
    "companyCapture.withSuggestion":
      "We identified this company from your email. You can confirm or correct it.",
    "companyCapture.noSuggestion":
      "We couldn't automatically find your company. Could you tell us?",
    "companyCapture.placeholder": "Your company name",
    "companyCapture.errorEmpty": "Please enter your company name",
    "companyCapture.confirm": "Confirm and see my results",
    "paused.title": "Your progress is saved.",
    "paused.body":
      "You can resume at any time from this link — your progress is stored in your browser.",
    "paused.copy": "Copy",
    "paused.copied": "Copied!",
    "paused.emailReminder":
      "You'll also receive a reminder email with this link.",
    "paused.continueNow": "Actually, I'll continue now",
    "loading.title": "We're analysing your answers — allow about a minute…",
    "loading.msg1":
      "We're cross-referencing your answers with what Be-one has learned in twenty years of B2B marketing.",
    "loading.msg2": "Analysis in progress (real reasoning, not copy-paste).",
    "loading.msg3":
      "Our AI agent is reading your answers carefully and thinking it through.",
    "loading.msg4":
      "We're weighing your answers against each other. Where they clash, there's something to learn.",
    "loading.msg5":
      "Your answers are talking to each other. The conversation is getting spicy.",
    "loading.msg6":
      "Our AI agent is drafting your analysis. We're making sure it isn't talking nonsense.",
    "loading.msg7":
      "Your results stay under lock and key. Your competitors can keep dreaming.",
    "loading.msg8":
      "We're writing your recommendations. Truth first, comfort second.",
    "loading.msg9": "Final polish. Anything not useful won't survive the edit.",
    "loading.msg10": "Alibi provided: you're working on your strategy.",
    "loading.msg11":
      "Time well spent. At the next board meeting, you'll be the only one with answers.",
    "themeComplete.title": "Theme {num}:",
    "themeComplete.continue": "Continue to theme {next}",
    "themeComplete.previous": "Previous",
    "radar.progress": "Theme {num}/4",
    "radar.ariaLabel": "The truth radar: your marketing scores",
    "radar.svgTitle": "The truth radar: your marketing scores",
    "radar.svgDesc":
      "Your four B2B pillars on the radar, scored out of 4. Some of them may be wobbling.",
    "results.title": "Your results",
    "results.subtitle": "Here is your assessment.",
    "results.situation": "Situation",
    "results.priority": "Your priority",
    "results.why": "Why this priority",
    "results.noAnalysis.line1":
      "The personalised analysis requires an internet connection.",
    "results.noAnalysis.line2": 'Reconnect and click "Retry" to receive it.',
    "results.retry": "Retry",
    "results.emailConfirm":
      "📩 These results and your personalised analysis have also been sent by email.",
    "results.downloadPdf":
      "Download the PDF… read it before your competitors do",
    "results.pdfFilename": "b2b-marketing-assessment-be-one.pdf",
    "results.cta": "Book a call to discuss it",
    "results.ctaHref": "https://be-one.net/fr/calendly",
    "results.ctaSubtext":
      "Your priority deserves more than a good intention. 30 minutes, one strategic read, one action plan. Pick your slot!",
    "results.restart": "Restart the assessment",
  },
  questions: assessmentQuestionsEn,
  feedback: {
    pillarFeedbacks: PILLAR_FEEDBACKS_EN,
    crossP2: CROSS_P2_EN,
    crossP3Uniforme: CROSS_P3_UNIFORME_EN,
    crossP3EnRetrait: CROSS_P3_EN_RETRAIT_EN,
    crossP3EnAvance: CROSS_P3_EN_AVANCE_EN,
  },
  radarAxisLabels: [
    "Strategy\n& Steering",
    "Brand\n& Experience",
    "Content\n& Visibility",
    "AI\n& Tools",
  ],
};

export default en;
